import axios from 'axios';
import { clearSession } from './session';

export function safeReturnPath(path) {
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') && !/[\\\r\n]/.test(path) && !/^\/(login|register)(?:[/?#]|$)/.test(path) ? path : null;
}
export function tokenExpired(token, now = Date.now()) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return Number.isFinite(payload.exp) && payload.exp * 1000 <= now;
  } catch { return false; } // o servidor valida tokens sem exp ou malformados
}
let redirecting = false;
export function expireSession() {
  if (redirecting || !sessionStorage.getItem('token')) return;
  redirecting = true;
  const path = safeReturnPath(window.location.pathname + window.location.search + window.location.hash);
  if (path) sessionStorage.setItem('loginReturnTo', path);
  clearSession();
  window.location.assign('/login?motivo=sessao-expirada');
}
function isProtectedApi(url) {
  try {
    const target = new URL(url, window.location.href);
    const base = new URL(process.env.REACT_APP_API_URL || window.location.origin, window.location.href);
    return target.origin === base.origin && target.pathname.startsWith('/api/') && !target.pathname.startsWith('/api/auth/');
  } catch { return false; }
}
export function installSessionHandling() {
  axios.interceptors.response.use(response => response, error => {
    if (error.response?.status === 401 && isProtectedApi(error.config?.url)) expireSession();
    return Promise.reject(error);
  });
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = typeof args[0] === 'string' || args[0] instanceof URL ? args[0] : args[0]?.url;
    if (response.status === 401 && isProtectedApi(url)) expireSession();
    return response;
  };
}
